import proyecto from "../../api/Proyecto";

// Obtener ventas filtradas por tipo: contado, crédito, abono, reparación
export const getVentasPorFecha = async (rango) => {
  const response = await proyecto.post("/reportes/ventas", rango);
  return response.data;
};

// Obtener todos los movimientos (sin filtrar por tipo)
export const getMovimientosPorFecha = async (rango) => {
  const response = await proyecto.post("/reportes/movimientos", rango);
  return response.data;
};

// Obtener detalle de una venta
export const getDetalleVenta = async (idVenta) => {
  const response = await proyecto.get(`/reportes/detalleventa/${idVenta}`);
  return response.data;
};

// Obtener ganancia (productos + servicios) por rango de fechas
export const getGananciasPorFecha = async ({ fechaInicio, fechaFin, tipo = "" }) => {
  const response = await proyecto.post("/reportes/ganancias", {
    fechaInicio,
    fechaFin,
    tipo,
  });
  return response.data;
};
